import { render, staticRenderFns } from "./ComCertResult.vue?vue&type=template&id=c71d8796&scoped=true&"
import script from "./ComCertResult.vue?vue&type=script&lang=js&"
export * from "./ComCertResult.vue?vue&type=script&lang=js&"
import style0 from "./ComCertResult.vue?vue&type=style&index=0&id=c71d8796&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71d8796",
  null
  
)

component.options.__file = "ComCertResult.vue"
export default component.exports